<template>
  <v-flex
    v-if="!loading"
    align-self-center
    justify-center
  >
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('campaign_manager') && currentUser.user.is_propagandist && currentUser.user.warehouses.length"
        @click="showBullettinByBookModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("PRINT_BY_BOOK") }}
      </v-btn>
      <v-btn
        v-if="can('campaign_manager') && currentUser.user.is_propagandist && currentUser.user.warehouses.length"
        @click="showBullettinManualModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("MANUAL_PRINTING") }}
      </v-btn>
      <v-btn
        v-if="can('campaign_manager')"
        @click="showBullettinModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("PRINT_ALL") }}
      </v-btn>
    </v-row>
    <v-row>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs2 class="mr-2">
        <Search
          v-model="filters.searchPropagandist"
          :label="$t('PROPAGANDIST')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | timeFormat }}
      </template>

      <template v-slot:item.actions="{ item }">
            <v-layout wrap>
              <v-flex>
                <v-btn
                  icon
                  @click="downloadPdf(item.pdf_id)"
                >
                    <v-icon>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <div class="pt-2">{{$t('fields.total_items')}} {{ totalItems }}</div>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchBullettins"
    />


  </v-flex>
  <Loader v-else/>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';

  import { bullettinService } from '../../utils/services/bullettins.service';
  import { reportService } from '../../utils/services/report.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import BullettinModal from '../../components/modals/Bullettins/BullettinModal.vue';
  import BullettinManualModal from '../../components/modals/Bullettins/BullettinManualModal.vue';
  import BullettinByBookModal from '../../components/modals/Bullettins/BullettinByBookModal.vue';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'BullettinList',
    components: { Search, Loader, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        errorBag: {},
        pagination: {
          page: 1,
          itemsPerPage: 20,
          sortDesc: [false],
          sortBy: ['title'],
        },
        headers: [
          { text: this.$t('fields.name'), value: 'name' },
          { text: this.$t('fields.propagandist'), value: 'propagandist' },
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.status'), value: 'status' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: true, align: 'center' },
        ],
        filters: {
          search: null,
          searchPropagandist: null,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      requestFilters() {
        const filters = {
          search: this.filters.search,
          propagandist: this.filters.searchPropagandist,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async fetchBullettins(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return bullettinService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      downloadPdf(id, filename) {
        return reportService.downloadPdf(id, filename);
      },

      openPdf(id) {
        return reportService.openPdf(id);
      },

      // Chiede conferma per generare il gruppo successivo di bollettini.
      confirmPrintMore() {
        return new Promise((resolve) => {
          this.showConfirm({
            title: this.$t('PRINT_BULLETTINS'),
            message: this.$t('BULLETTIN_PRINT_MORE_CONFIRM'),
            confirmMessage: this.$t('YES'),
            rejectMessage: this.$t('NO'),
            onConfirm: () => resolve(true),
            onReject: () => resolve(false),
          });
        });
      },

      // Genera il bollettino e, finché il backend segnala altri gruppi da
      // stampare (has_more), chiede conferma e genera il gruppo successivo.
      async handleBullettinSave(form, errors) {
        try {
          let response = await bullettinService.create(form);
          this.hideModal({});
          this.showToast({ type: 'success', message: this.$t('SAVED') });
          await this.fetchBullettins(this.pagination.page);
          this.openPdf(response.data.pdf_id);

          while (response.data.has_more) {
            const goOn = await this.confirmPrintMore();
            if (!goOn) {
              break;
            }
            response = await bullettinService.create(form);
            await this.fetchBullettins(this.pagination.page);
            this.openPdf(response.data.pdf_id);
          }
        } catch (error) {
          this.handleError(error, errors);
        } finally {
          this.hideModal({});
        }
      },

      async showBullettinManualModal(id) {
        this.showModal({
          component: BullettinManualModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('PRINT_BULLETTINS'),
            fullscreen: true,
            onSave: (form, errors) => this.handleBullettinSave(form, errors),
          },
        });
      },

      async showBullettinByBookModal(id) {
        this.showModal({
          component: BullettinByBookModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('PRINT_BULLETTINS'),
            fullscreen: true,
            onSave: (form, errors) => this.handleBullettinSave(form, errors),
          },
        });
      },

      async showBullettinModal(id) {
        this.showModal({
          component: BullettinModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('PRINT_BULLETTINS'),
            onSave: (form, errors) => this.handleBullettinSave(form, errors),
          },
        });
      },

    },
    async created() {
      await this.fetchBullettins(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchBullettins(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBullettins(1);
          }
        },
      },

    },
  };
</script>
